import { z } from "zod";

export const AGENT_RULE_ACTOR_TYPE_VALUES = [
  "USER",
  "AGENT_WORKFLOW_RUN",
] as const;

export const AgentRuleActorTypeSchema = z.enum(AGENT_RULE_ACTOR_TYPE_VALUES);
export type AgentRuleActorType = z.infer<typeof AgentRuleActorTypeSchema>;
export const AGENT_RULE_ACTOR_TYPE = AgentRuleActorTypeSchema.enum;

export const AgentRuleSchema = z.object({
  id: z.string(),
  content: z.string(),
  actorId: z.string(),
  actorType: AgentRuleActorTypeSchema,
  actorName: z.string().nullable().optional(),
  organizationId: z.string(),
  archivedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AgentRule = z.infer<typeof AgentRuleSchema>;

export const CreateRuleParamsSchema = z.object({
  content: z.string(),
  actorId: z.string(),
  actorType: AgentRuleActorTypeSchema,
  organizationId: z.string(),
});

export type CreateRuleParams = z.infer<typeof CreateRuleParamsSchema>;

export const AgentRulesFilterSchema = z.object({
  search: z.string().optional(),
  includeArchived: z.boolean().optional(),
});

export type AgentRulesFilter = z.infer<typeof AgentRulesFilterSchema>;

export const ListAgentRulesResponseSchema = z.object({
  rules: z.array(AgentRuleSchema),
});

export type ListAgentRulesResponse = z.infer<
  typeof ListAgentRulesResponseSchema
>;

export const CreateAgentRuleResponseSchema = z.object({
  rule: AgentRuleSchema,
});

export type CreateAgentRuleResponse = z.infer<
  typeof CreateAgentRuleResponseSchema
>;

export const UpdateAgentRuleResponseSchema = z.object({
  rule: AgentRuleSchema,
});

export type UpdateAgentRuleResponse = z.infer<
  typeof UpdateAgentRuleResponseSchema
>;

export const GetAgentRuleResponseSchema = z.object({
  rule: AgentRuleSchema,
});

export type GetAgentRuleResponse = z.infer<typeof GetAgentRuleResponseSchema>;
